<template>
  <section class="contact">
    <h1 class="contact-section-title">Contacto</h1>
    <div class="columns is-tablet info">
      <p class="column">
        <strong>Dirección:</strong>
        <br>
        Centro Comercial Tikal Futura, Calzada Roosevelt 22-43 zona 11.
        <br><br>
        <strong>Horario de Atención:</strong>
        <br>
        Lunes a viernes funciones a partir de las 14:00 horas.
        <br>
        Sábado y domingo matinal a partir de las 10:00 horas.
        <br><br>
        <strong>Programación:</strong>
        <br>
        Entrada 2D: Q.35.00  -  Entrada 3D: Q.45.00.
        <br>
        Programación de jueves a miércoles.
        <br>
        Programación sujeta a cambios sin previo aviso.
        <br><br>
      </p>
      <div class="column logo">
        <img
          src="@/assets/cineflick-logo.png"
          srcset="@/assets/cineflick-logo.png 1x,
          @/assets/cineflick-logo@2x.png 2x, @/assets/cineflick-logo@3x.png 3x"
          alt="CineFlick"
          width="320">
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Contact',
};
</script>

<style lang="scss">
@import "~bulma/sass/utilities/initial-variables";
@import "~bulma/sass/utilities/functions";
@import "~bulma/sass/utilities/derived-variables";
@import "~bulma/sass/utilities/mixins";
@import "~@/sass/variables";

.contact {
  margin-bottom: 2rem;
  padding: 0 4%;

  .contact-section-title {
    color: lighten($dark-cyan-gray, 30);
    font-weight: bold;
    text-transform: uppercase;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    font-size: 1.25rem;

    @include from(1000px) {
      font-size: 1.5rem;
    }
  }

  p {
    margin-top: 1rem;
    color: #FFF;

    strong {
      text-transform: uppercase;
      color: #FFF;
    }
  }

  .logo {
    align-items: center;
    justify-content: center;
    display: flex;

    img {
      width: 80%;
      max-width: 360px;
    }

    @include tablet {
      justify-content: start;

      img {
        width: 100%;
        max-width: 420px;
        margin-top: -2rem;
      }
    }
  }
}
</style>
